<template>
  <div class="btn-wrapper" v-if="loaded">
    <button
      type="button"
      :class="{'applied': deadline}"
      :disabled="deadline"
      @click.prevent="clickBtn"
    >
      {{ entryBefore | setButtonLabel(finishFesta, deadline) }}
    </button>
  </div>
</template>

<script>
export default {
  data: () => ({
    isDisabled: false
  }),
  props: {
    loaded: {
      type: Boolean,
      required: true
    },
    isAuthed: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    entryBefore () {
      return this.$moment().isBefore('2020-07-28', 'day')
    },
    finishFesta () {
      return this.$moment().isAfter('2020-07-29', 'day')
    },
    deadline () {
      const now = this.$moment(new Date())
      const deadlineAt0828 = this.$moment('2020-07-29 15:40')
      const at0828 = this.$moment('2020-07-29 00:00:00')
      // 28日の締め切り時間
      if (now.diff(deadlineAt0828) > 0) {
        return true
      }
      // 28日の0時から応募受付開始
      if (now.diff(at0828) > 0) {
        return false
      }
      const deadline = this.$moment('2020-07-28 15:40')
      return deadline.diff(now) < 0
    }
  },
  methods: {
    clickBtn () {
      if (this.entryBefore) {
        window.open('https://l-ma.co.jp/events/5106', '_blank')
      } else {
        if (!this.isAuthed) {
          this.$emit('to-login')
        } else {
          if (this.$moment().isSame('2020-07-28', 'day')) {
            window.open('https://ws.formzu.net/dist/S50378831/', '_blank')
          } else if (this.$moment().isSame('2020-07-29', 'day')) {
            window.open('https://ws.formzu.net/dist/S70614357/', '_blank')
          }
        }
      }
    }
  },
  filters: {
    setButtonLabel (entryBefore, finishFesta, deadline) {
      if (entryBefore) {
        return '無料参加チケットを取得'
      }
      if (finishFesta) {
        return '終了しました'
      }
      return '抽選会に応募する（15:40まで）'
    }
  }
}
</script>

<style lang="sass" scoped>
.btn-wrapper
  width: 100%
  max-width: 320px
  margin: 0 auto
  button
    display: flex
    justify-content: center
    align-items: center
    width: 100%
    height: 56px
    color: #fff
    background-color: $green
    border: none
    border-radius: 8px
    padding: 0
    margin: 0 auto
    font-size: 1.6rem
    cursor: pointer
  .applied
    background-color: gray
</style>
